
import { Component, Vue, Prop } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

const ViewTaskTemplateModalProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean,
    id: Number,
    obj: undefined,
    active: Boolean,
    promptResults: Array,
    selectedUserId: Number
  }
})

@Component
export default class ViewTaskTemplateModal extends ViewTaskTemplateModalProps {
  data () {
    return {
      isLoading: false,
      testQuote: ''
    }
  }

  get isComponentModalActive () {
    return this.close
  }

  getFormattedKeywords () {
    return this.obj.keywords ? this.obj.keywords.join(', ') : ''
  }

  newPromptResult (testQuote, testOutput) {
    this.$emit('newPromptResult', { id: this.id, testQuote, testOutput })
  }

  async testPrompt () {
    try {
      this.isLoading = true
      var body = {
        prompt: `${this.obj.prompt} "${this.testQuote}"`
      }
      var resp = await FetchWrapper.post(encodeURI(`${process.env.VUE_APP_SERVERURL}/runTaskTemplateInference/${this.selectedUserId}`), body)
      if (resp.error) {
        this.isLoading = false
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.newPromptResult(this.testQuote, resp.result)
        this.isLoading = false
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }

  async activateOrChangeActive () {
    try {
      this.isLoading = true
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/addOrChangeActiveTaskTemplate/${this.selectedUserId}/${this.id}`))
      if (resp.error) {
        this.isLoading = false
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.$emit('activeTaskTemplateChanged', this.id)
        this.isLoading = false
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }
}
